module.exports = __webpack_public_path__ + "81877f733b9de2e15d7f7dce9dbbcab3.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/Foto_Manja_Herrmann-0187_klein.jpg
// module id = 599
// module chunks = 0